(function () {
  var drawer = document.querySelector('[data-lumera-cart-drawer]');
  if (!drawer) return;

  var body = drawer.querySelector('[data-lumera-cart-body]');
  var subtotalEl = drawer.querySelector('[data-lumera-cart-subtotal]');
  var reassuranceEl = drawer.querySelector('[data-lumera-cart-reassurance]');

  function escapeHtml(str) {
    return (str || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function open() {
    drawer.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    refresh();
  }

  function close() {
    drawer.classList.remove('open');
    document.documentElement.style.overflow = '';
  }

  drawer.querySelectorAll('[data-lumera-cart-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });

  document.querySelectorAll('[data-lumera-cart-toggle]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      open();
    });
  });

  function renderLine(item) {
    var variant = item.variant_title ? '<div class="lumera-cart-line-variant">' + escapeHtml(item.variant_title) + '</div>' : '';
    return (
      '<div class="lumera-cart-line" data-line-key="' + item.key + '">' +
        '<div class="lumera-cart-line-img"><img src="' + (item.image ? item.image.replace('{width}', '128') : '') + '" alt="' + escapeHtml(item.product_title) + '" width="64" height="64"></div>' +
        '<div>' +
          '<div class="lumera-cart-line-title">' + escapeHtml(item.product_title) + '</div>' +
          variant +
          '<div class="lumera-cart-line-qty">' +
            '<button type="button" data-lumera-cart-decrease data-key="' + item.key + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + item.quantity + '</span>' +
            '<button type="button" data-lumera-cart-increase data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<div class="lumera-cart-line-price">' + Lumera.formatMoney(item.final_line_price) + '</div>' +
        '<button type="button" class="lumera-cart-line-remove" data-lumera-cart-remove data-key="' + item.key + '" aria-label="Remove item">&times;</button>' +
      '</div>'
    );
  }

  function render(cart) {
    if (!cart.items.length) {
      body.innerHTML = '<div class="lumera-cart-empty">Your cart is empty.<br><a href="/collections/all">Continue shopping</a></div>';
    } else {
      body.innerHTML = cart.items.map(renderLine).join('');
    }
    subtotalEl.textContent = Lumera.formatMoney(cart.total_price);
    bindLineEvents();
    if (reassuranceEl) reassuranceEl.hidden = !cart.items.length;
  }

  function refresh() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function changeQuantity(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        Lumera.updateCartCount();
      });
  }

  function bindLineEvents() {
    body.querySelectorAll('[data-lumera-cart-increase]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = body.querySelector('[data-line-key="' + btn.dataset.key + '"]');
        var qtyEl = line.querySelector('.lumera-cart-line-qty span');
        changeQuantity(btn.dataset.key, parseInt(qtyEl.textContent, 10) + 1);
      });
    });
    body.querySelectorAll('[data-lumera-cart-decrease]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = body.querySelector('[data-line-key="' + btn.dataset.key + '"]');
        var qtyEl = line.querySelector('.lumera-cart-line-qty span');
        var next = parseInt(qtyEl.textContent, 10) - 1;
        changeQuantity(btn.dataset.key, Math.max(0, next));
      });
    });
    body.querySelectorAll('[data-lumera-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeQuantity(btn.dataset.key, 0); });
    });
  }

  window.Lumera = window.Lumera || {};
  window.Lumera.openCartDrawer = open;
  window.Lumera.closeCartDrawer = close;
  window.Lumera.refreshCartDrawer = refresh;
})();
